export default "__VITE_ASSET__DIf4$5m2__"